import firebase from 'firebase/compat/app'

/**
 * Cierra la sesión de Firebase de ESTA pestaña.
 *
 * La persistencia está fijada en `SESSION` (ver `src/firebase.js`), así que el `currentUser` que ve
 * esta pestaña es siempre el suyo: cerrarlo no puede afectar a otra pestaña, ni aunque tenga otro
 * usuario. Sin este cierre el logout solo borra el JWT propio y al recargar
 * `recoverSessionFromFirebase` vuelve a canjear el refresh token guardado: la sesión "revivía" sola.
 *
 * Es best-effort: si falla, el logout local ya ocurrió y no queremos romperlo.
 */
export const signOutFirebaseSession = async (): Promise<boolean> => {
    try {
        if (!firebase.auth().currentUser) return false
        await firebase.auth().signOut()
        return true
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('[Auth] No se pudo cerrar la sesión de Firebase:', error)
        return false
    }
}
